export const GET_SERVICES = "GUEST/get_services";
export const RECHARGE_ACCOUNT = "GUEST/RECHARGE_account";
export const RECHARGE_ACCOUNT_CALLBACK = "GUEST/RECHARGE_accountCallback";
export const RECHARGE_PRE_AMOUNTS = "GUEST/RECHARGE_predefinedAmounts";
export const PAY_VOUCHER = "GUEST/pay_voucher";
export const PAY_POSTPAID = "GUEST/pay_postpaid";
export const PAY_FIXEDLINE = "GUEST/pay_fixedline";
